import { render, staticRenderFns } from "./GetMorePoints.vue?vue&type=template&id=4ee24b86&scoped=true&"
import script from "./GetMorePoints.vue?vue&type=script&lang=js&"
export * from "./GetMorePoints.vue?vue&type=script&lang=js&"
import style0 from "./GetMorePoints.vue?vue&type=style&index=0&id=4ee24b86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee24b86",
  null
  
)

export default component.exports